'use strict'

import React from 'react';
import uuid from 'uuid';

import DragAndDropContent from './DragAndDropContent.jsx';
import DragAndDropTarget from './DragAndDropTarget.jsx';
import DragAndDropSource from './DragAndDropSource.jsx';
import FormattedContent from './FormattedContent.jsx';


let height=20;

class EditCell extends React.Component {
  constructor(props) {
    super(props);
    this.state={ value: this.props.sample? "" : this.props.value,
                  height: height*this.props.height };
  }

  onChange(event) {
    this.setState({value:event.target.value});
    if (this.props.onUpdate!==undefined) {
      this.props.onUpdate({preventDefault:event.preventDefault,target:{name: this.props.name, value:event.target.value}});
    }
    this.calculateSize();
  }

  componentDidMount() {
    this.calculateSize();
  }

  calculateSize() {
    this._textarea.style.height = 'auto';
    if (this._textarea.scrollHeight> height*this.props.height) {
      this._textarea.style.height = (this._textarea.scrollHeight+2)+'px';
    } else {
      this._textarea.style.height = height*this.props.height+'px';
    }
  }

  expand(event) {
    this.calculateSize();
    if (this.props.onChange!==undefined) {
      this.props.onChange(event);
    }
  }


  render() {

    return (
      <div>
        <div>
          <textarea autoFocus
                    ref={(ref)=>this._textarea=ref}
                    onChange={this.onChange.bind(this)}
                    style={{width:"100%", resize: "none", minHeight:15, fontFamily: "Lato, Arial, Verdana, Geneva, sans-serif", borderStyle: "none", fontSize: "12pt"}}
                    defaultValue={this.props.sample ? "" : this.props.value}
                    placeholder={this.props.sample ? this.props.value : ""}/>
        </div>

      </div>
    );
  }
}

class DisplayValue extends React.Component {
  render() {
    let languageLabels={
      norwegian: {
        empty: "(tom linje)"
      },
      english: {
        empty: "(empty line)"
      }
    };
    let labels=(languageLabels[this.props.language] || languageLabels["english"]);
    var style=this.props.type==="date" ? {whiteSpace:"nowrap"} : {};
    switch (this.props.displayAs) {
      case "_disabled" :
        style=Object.assign({},style,{color: "#D5D5D5",fontStyle: "italic"});
        break;
      case "_highlight" :
        style=Object.assign({},style,{color:"black", fontWeight: "bold"});
        break;
      case "_normal" :
        style=Object.assign({},style,{color:"#757575"});
        break;

      default:
        if (this.props.sample!==undefined) {
          style={color:"#757575"};
        }
    }
    return this.props.priority ? (
      <div style={Object.assign({},style,{textAlign:"center", verticalAlign:"top"})}>
        {this.props.pri}
      </div>
    ) : (
      <div style={style}>
        {this.props.editable && this.props.sample!==true ? (
            <div style={{float:"right", cursor:"pointer"}}><img src="/icons/pen_grey_tran.png"/></div>
          ) : null}
        {this.props.format!==undefined
          ? this.props.format(this.props.value,this.props.name,this.props)
          : this.props.value !==undefined && this.props.value!==null && this.props.value.length>0  ? (
          <FormattedContent value={this.props.value}/>
        ) : this.props.includeEmptyLine ? (
          <i>{labels.empty}</i>
        ) : undefined}
      </div>
    );
  }
}

class DisplayCell extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      edit:false,
      value:this.props.value
    };
  }

  render() {
    return this.props.dragable && this.props.sample===undefined ? (
      <DragAndDropTarget position={this.props.pri-1}>
        <DragAndDropSource prioritize={this.props.prioritize} id={this.props.id}>
          <DisplayValue {...this.props}/>
        </DragAndDropSource>
      </DragAndDropTarget>
    ) : (
      <DisplayValue {...this.props}/>
    );
  }
}

class TableCell extends React.Component {
  constructor(props) {
    super(props);
    this.state={edit:false};
  }

  edit(event) {
    if (this.props.entryEditable) {
      this.props.onEditEntry();
    } else {
      this.setState({edit:!this.state.edit});
    }
  }

  update(event) {
    if (this.props.onUpdate!==undefined) {
      this.props.onUpdate(event);
    }
  }

  render() {
    var cursor= (this.props.dragable && this.props.sample!==true && !this.props.entryEditable) ? "normal" : (this.props.editable) && !this.state.edit ? "text" : this.props.entryEditable ? "pointer" : "normal";
    let useSummaryRow=this.props.options!==undefined ? this.props.options.summaryRow : undefined;
    let borderColor="#d9d9d9";
    let cellColor=(this.props.lastRow && !this.props.editable && useSummaryRow!==undefined) || (!this.props.editable && !this.props.entryEditable)  ? "#f0f0f0" : "#ffffff";
    return (
      <div  onClick={this.props.editable && !this.state.edit || this.props.entryEditable ? this.edit.bind(this) : undefined}
            style={{backgroundColor:cellColor, verticalAlign:"top", display:"table-cell", cursor:cursor, padding:5, height: 20, borderRight:this.props.last ? undefined : "solid 1px "+borderColor, borderTop:"solid 1px #d9d9d9", borderRadius: this.props.lastRow && this.props.first && this.props.last ? "0 0 5px 5px" : this.props.lastRow && this.props.last ? "0 0 5px 0px" : this.props.lastRow && this.props.first ? "0 0 0 5px" : 0}}>
        {(this.props.editable || this.props.entryEditable) && !this.props.forceReadOnly && this.state.edit ? (
          <EditCell {...this.props} cancel={this.edit.bind(this)} onUpdate={this.update.bind(this)} height="1"/>
        ) : (
          <DisplayCell {...this.props}/>
        )}
      </div>

    );
  }
}

class TableRow extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      value: props.value.content
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      value: props.value.content
    });
  }

  updateValue(event) {
    event.preventDefault();
    var updated=Object.assign({},this.state.value,{[event.target.name]:event.target.value});
    this.setState({value:updated},()=>{
      if (this.props.onChange) {
        let newItem={id: this.props.value.id, content:updated};
        this.props.onChange(newItem);
      }
    });
  }

  onEditEntry() {
    if (this.props.onEditEntry!==undefined) {
      this.props.onEditEntry(this.state.value);
    }
  }

  render() {
    let useSummaryRow=this.props.options!==undefined ? this.props.options.summaryRow : undefined;
    let background=this.props.lastRow && useSummaryRow!==undefined ? "#d8d8d8": "#ffffff";
    return (
      <div style={{display:"table-row", backgroundColor:background}}>
        {this.props.columns.map((column,index)=>
          <TableCell
            key={index}
            {...this.props}
            {...column}
            index={index}
            first={index===0}
            last={(index+1)===this.props.columns.length}
            id={this.props.value.id}
            name={column.name}
            onUpdate={this.updateValue.bind(this)}
            value={this.state.value!==undefined ? this.state.value[column.name] : undefined}
            displayAs={this.props.value!==undefined && this.props.value.content!==undefined ? this.props.value.content._displayAs : undefined}
            format={this.props.value!==undefined && this.props.value.content!==undefined ? this.props.value.content._format : undefined}
            sample={this.props.value.sample}
            onEditEntry={this.props.onEditEntry!==undefined ? this.onEditEntry.bind(this) : undefined}
          />
        )}
      </div>

    );
  }
}

export default class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state={items: this.ensureEmptyLine(this.loadRows(props)),
                forceUpdate: this.props.forceReadOnly!== undefined ? this.props.forceReadOnly : false};
  }

  loadRows(props) {
    return props.value!==undefined
      ? props.value.map((item,index)=>({
          id:uuid.v4(),
          content:item
        }))
      : [];
  }

  componentWillReceiveProps(props) {
    this.setState({items:this.ensureEmptyLine(this.loadRows(props))});
  }

  ensureEmptyLine(values) {
    return this.props.includeEmptyLine ? values.concat({id:uuid.v4(),content:undefined}) : values; //values===undefined ? [] : values;
  }

  isEmpty(values) {
    return values===undefined || values.length===0 || values.filter(entry=>this.containValue(entry)).length===0;
  }

  emptyLines(values) {
    return values.filter(entry=>!this.containValue(entry));
  }

  containValue(entry) {
    return entry.content!==undefined &&
      Object.keys(entry.content)
        .filter(field=>entry.content[field]!==undefined && entry.content[field]!==null && entry.content[field].length>0 &&
          field!=="id")
      .length>0;
  }

  prioritizeLine(item,target) {
    let before=target.position>0 ? this.state.items.slice(0,target.position).filter(entry=>entry.id!==item.id) : [];
    let selected=this.state.items.filter(entry=>entry.id===item.id)[0];
    let after=this.state.items.slice(target.position).filter(entry=>entry.id!==item.id);
    let updatedItems=[].concat(before,selected,after);
    this.setState({items:updatedItems});
    if (this.props.onChange!==undefined) {
      this.props.onChange({
        target: {
          name:this.props.name,
          value:updatedItems
            .filter(entry=>this.containValue(entry))
            .map(item=>item.content)
          },
        details: {
          action: "prioritize",
          item: selected.content.id,
          position: target.position
        }
      });
    }
    this.setState({forceUpdate:true});
    this.forceUpdate();
    this.setState({forceUpdate:false});
  }


  updateLine(item) {
    let updatedItems=
      this.state.items
        .map(entry=>entry.id===item.id ? item : entry)
        .filter(entry=>this.containValue(entry))
      ;
    this.setState({items:this.ensureEmptyLine(updatedItems)});
    if (this.props.onChange!==undefined) {
      this.props.onChange({target: {name:this.props.name, value:updatedItems.map(item=>item.content)}});
    }
  }

  render() {
    let headers=[];
    if (this.props.columnHeaders!==undefined) {
      this.props.columnHeaders.forEach(header=>{
        if (this.props._hideColumnHeader!==undefined && this.props._hideColumnHeader.includes(header.name)) {
          headers=headers.concat(Object.assign({},header,{title:""}));
        } else {
          headers=headers.concat(header);
        }
        for (var index=1; index<header.columns; index++) {
          headers=headers.concat(undefined);
        }
      });
    }
    return (
      <DragAndDropContent>
        <div style={{width:"100%", display:"table", marginBottom:10, border: "solid 1px #d9d9d9", borderRadius: 0}}>
          {this.props.columnHeaders!==undefined ? (
            <div style={{display:"table-row", backgroundColor:"#7F7F7F", color:"white"}}>
              {this.props.columns.map((column,index)=>(
                <div key={index} style={{display: "table-cell", fontWeight: "bold", padding: 5, borderRight:(index+1)<this.props.columns.length ? headers[index+1]!==undefined ? "solid 1px white":undefined:undefined, borderBottom:"solid 4px white", borderMargin: 4,  borderRadius:(this.props.columns.length===1) ? "0 0 0 0" : (index===0) ? "0 0 0 0" : (index+1)===this.props.columns.length ? "0 0 0 0" : 0}}>
                  {headers[index]!==undefined ? headers[index].title!==undefined ? headers[index].title : ".("+headers[index].name+")" : null}
                </div>
              ))}
            </div>
          ) : null }
          <div style={{display:"table-row", backgroundColor:"#7F7F7F", color:"white"}}>
            {this.props.columns.map((column,index)=>(
              <div key={index} style={{display:"table-cell", width: column.priority ? 40 : undefined, padding:5, borderRight:(index+1)<this.props.columns.length ? "solid 1px white":undefined, borderRadius: this.props.columnHeaders===undefined ? (this.props.columns.length===1) ? "0 0 0 0" : (index===0) ? "0 0 0 0" : (index+1)===this.props.columns.length ? "0 0 0 0" : 0 : undefined}}>{column.title!==undefined ? column.title : ".("+column.name+")"}</div>
            ))}
          </div>
          {this.isEmpty(this.state.items) && this.props.samples!==undefined ? this.props.samples.map((item,index,items)=>
            <TableRow
              key={index}
              {...this.props}
              value={item.id!==undefined
                ? {id: item.id, content:item, sample:true}
                : this.state.items!==undefined && this.state.items.length>0
                  ? {id:this.emptyLines(this.state.items)[0].id,content:item, sample:true}
                  : {id:uuid.v4(),content:item, sample:true} }
              pri={index+1}
              onChange={this.updateLine.bind(this)}
              lastRow={index+1===items.length}
            />
          ) : this.state.items.map((item,index,items)=>
            <TableRow
              key={index}
              {...this.props}
              value={item}
              pri={index+1}
              prioritize={this.prioritizeLine.bind(this)}
              onChange={this.updateLine.bind(this)}
              lastRow={index+1===items.length}
              entryEditable={this.props.onEditEntry!==undefined && this.props.options!==undefined && this.props.options.edit!==undefined}
              forceReadOnly={this.state.forceUpdate}
            />
          )}
        </div>
        {this.props.description!==undefined ? (
          <div style={{fontStyle:"italic", paddingLeft:15, paddingRight: 15}}><FormattedContent value={this.props.description}/></div>
        ) : null}
      </DragAndDropContent>
    );
  }
}



// WEBPACK FOOTER //
// ./views/components/Table.jsx